import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from './store';

// auth
export const selectorAuthState = (state: RootState) => state.auth;
export const authStatusSelector = createSelector([selectorAuthState], (auth) => auth.authStatus);
export const authoritiesListSelector = createSelector(
  [selectorAuthState],
  (auth) => auth.authoritiesList
);
export const traitsSelector = createSelector([selectorAuthState], (auth) => auth.traits);
export const logoutURLSelector = createSelector([selectorAuthState], (auth) => auth.logoutUrl);

// common
export const selectorLayoutState = (state: RootState) => state.layout;
export const speedDialButtonSelector = createSelector(
  [selectorLayoutState],
  (speedDial) => speedDial.buttons
);
export const sideBarSelector = createSelector(
  [selectorLayoutState],
  (sideBar) => sideBar.openSideBar
);
export const headerTitleSelector = createSelector(
  [selectorLayoutState],
  (sideBar) => sideBar.headerTitle
);

//notification
export const selectorNotificationState = (state: RootState) => state.notification;
export const notificationSelector = createSelector(
  [selectorNotificationState],
  (state) => state.notifications
);
